// extracted by mini-css-extract-plugin
export default {"page":"sQbGkr4S","backButton":"sG2jjm2a","nextButton":"GuZTnr9E"};
    if(module.hot) {
      // 1721069999468
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  